import styled from 'styled-components';
import { Color } from '../../base';

const InputWrapper = styled.input`
  border-radius: 4px;
  padding: 12px 20px;
  width: 100%;
  outline: none;
  font-size: 16px;
  border: solid 1px #e9edf4;
  background-color: #fafdff;
  transition: all ease 0.4s;
  &:focus,
  &:active {
    background-color: ${Color.white};
    border: solid 1px #67748b;
  }
  ::placeholder {
    color: #adb6c6;
  }
`;

const InputLabel = styled.label`
  display: block;
  color: ${Color.blackLight};
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 10px;
`;

export { InputWrapper, InputLabel };
